/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue';
import './ui-kit/app';
import './bootstrap';
import store from './store/store';
import {router} from './router';
import App from './pages/App';
import './bus/listener';
import ElementUI from 'element-ui';
import {ServerTable} from 'vue-tables-2';
import locale from 'element-ui/lib/locale/lang/en'
import Avatar from 'vue-gravatar';
import JsonCSV from 'vue-json-csv';
import VueDataTables from 'vue-data-tables'
import ACL from './mixins/Access.js';
import LoadProject from './mixins/LoadProject';
import 'vue-select/dist/vue-select.css';
import 'element-ui/lib/theme-chalk/index.css';
import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
    loaderOptions: {
        useRecaptchaNet: true,
        autoHideBadge: true
    }
})
Vue.use(ElementUI, {locale});
Vue.use(VueDataTables);
Vue.use(ServerTable, {skin: "table table-striped table-hover thead-dark small js-table-checkable"}, false, 'bootstrap4');
Vue.component('avatar', Avatar);
Vue.component('downloadCsv', JsonCSV);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('eml-pagination', require('./pages/utils/pagination/VuePagination').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding pages to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component('ui-breadcrumb', require('./pages/utils/Breadcrumb.vue').default);
Vue.use(ACL);
Vue.mixin(LoadProject);


new Vue({
    data: () => {
        return {
            windowWidth: 0,
            windowHeight: 0,
        }
    },

    created() {
        this.$nextTick(() => {
            window.addEventListener('resize', () => this.handleResize);
            this.handleResize();
        })
    },

    destroyed () {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
    },
    store,
    router,
    render: h => h(App)
}).$mount('#app-root');
